<template>
  <div>
    <div
      v-if="
        [
          'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
          'DIRECTIVOS ACADÉMICOS (CAMPUS)',
        ].some((group) => user.group_names.includes(group)) || user.is_superuser
      "
    >
      <span
        v-if="Information && Information.update_date != null && infoUserEmail"
        class="container-modification-date"
      >
        {{ $t("reusable.modificationDate.lastModification") }}
        <strong>{{ infoUserEmail }}</strong>
        {{ $t("reusable.modificationDate.on") }}
        <strong>{{ Information.update_date | FormatToDate }}</strong>
        <!-- a las
        <strong>{{ Information.update_date | FormatToTime }}</strong> -->
      </span>
      <span
        v-else-if="
          Information && Information.creation_date != null && infoUserEmail
        "
        class="container-modification-date"
      >
        {{ $t("reusable.modificationDate.createdBy") }}
        <strong>{{ infoUserEmail }}</strong>
        {{ $t("reusable.modificationDate.on") }}
        <strong>{{ Information.creation_date | FormatToDate }}</strong>
        <!-- a las
        <strong>{{ Information.creation_date | FormatToTime }}</strong> -->
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ModificationDate",
  components: {},
  props: {
    Information: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
    infoUserEmail() {
      // created_by/updated_by ya traen el email desde el backend
      if (!this.Information) return null;
      if (this.Information.updated_by != null)
        return this.Information.updated_by;
      else return this.Information.created_by;
    },
  },
  methods: {},
};
</script>

<style scoped>
.container-modification-date {
  font-size: 10pt;
}
</style>